<div class="desktop-iti-list">
    <div class="ion-text-center">
        <h2>Your Clinical Experiences Itinerary</h2>
        <ion-button (click)="whatIsItinerary()" class="iti-info-btn" fill="clear">
            What is my Itinerary
            <fa-icon style="margin-left: 0.2em; vertical-align: middle" [icon]="faQuestionCircle"></fa-icon>
        </ion-button>
    </div>

    <ion-row class="ion-text-center">
        <ion-col size="3">
            <p class="iti-col-header">Dates</p>
        </ion-col>
        <ion-col size="3">
            <p class="iti-col-header">Experience</p>
        </ion-col>
        <ion-col size="2">
            <p class="iti-col-header">Type</p>
        </ion-col>
        <ion-col size="2">
            <p class="iti-col-header">Location</p>
        </ion-col>
        <ion-col size="1">
            <p class="iti-col-header">Price</p>
        </ion-col>
    </ion-row>
    <div class="iti-row" *ngFor="let item of itineraryList$ | async; let i = index; trackBy: trackByIndex">
        <app-itinerary-create-items [itineraryItem]="item" [index]="i"> </app-itinerary-create-items>
    </div>
</div>
<div class="mobile-iti-list">
    <div>
        <div class="ion-text-center">
            <h3>
                <ion-label>Your Clinical Experiences Itinerary</ion-label>
            </h3>
        </div>
        <div class="ion-text-center">
            <ion-button (click)="whatIsItinerary()" class="iti-info-btn" fill="clear">
                What is my Itinerary
                <fa-icon style="margin-left: 0.2em; vertical-align: middle" [icon]="faQuestionCircle"></fa-icon>
            </ion-button>
        </div>

        <ion-list class="ion-no-margin">
            <ion-item
                class="iti-row iti-mobile-item ion-no-padding ion-no-margin"
                *ngFor="let item of itineraryList$ | async; let i = index; trackBy: trackByIndex"
            >
                <app-itinerary-create-items-mobile [itineraryItem]="item" [index]="i" style="width: 100%"></app-itinerary-create-items-mobile>
            </ion-item>
        </ion-list>
    </div>
</div>
